<dx-data-grid
  id="gridContainer"
  [dataSource]="optionData.optionPriceInformation"
  [showBorders]="true"
  [wordWrapEnabled]="true"
  (onRowInserted)="addOptionPricePossible($event)"
  (onRowRemoved)="addOptionPricePossible($event)"
  (onContentReady)="addOptionPricePossible($event)"
>
  <dxo-paging [enabled]="false"></dxo-paging>
  <dxo-editing
    mode="form"
    [allowUpdating]="true"
    [allowAdding]="allowAdding"
    [allowDeleting]="true"
  >
  </dxo-editing>

  <dxi-column dataField="price" [caption]="'Price ($)'"> </dxi-column>
</dx-data-grid>
